<template>
  <!--
    Declaration sample :
    <item-table :datatable="sysacq_table" />

    <script>
      import CardCustom from "../components/UI_kit/ItemTable.vue"

      export default {
        components: {
          ItemTable,
        },
      }

      data() {
          return {
            sysacq_table: [
              {
                icon: 'mdi:numeric-2-box',
                icon_color: 'orange',
                category: 'Sonde température module',
                message: 'Message 1, Message 2, Message 3',
              },
              {
                icon: 'mdi:numeric-1-box',
                icon_color: 'blue',
                category: 'Communication site',
                message: 'Message 1',
              },
            ]
          }
        }
    </script>
  -->

  <v-simple-table v-bind="$attrs" v-if="data !== undefined">
    <template v-slot:default>
      <tbody>
        <tr
          v-for="item in data"
          :key="item.name"
          class="py-0"
          v-bind="$attrs"
        >
          <td class="pl-2 pr-0 pt-1 mx-0">
            <Icon :icon="item.icon" :color="item.icon_color" style="font-size: 24px" />
          </td>
          <td id="table-cell">
            {{ $t(item.category) }}
          </td>
          <td id="table-cell" class="px-0 mx-0">
            <div v-for="msg in splitBySeparator(item.message, '|')" :key="msg">
              {{ $t(msg) }}
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>


<script>
    import { Icon } from '@iconify/vue2'

    export default {
      name: "ItemTable",

      components: {
        Icon,
      },

      props: {
        datatable: {
          type: Array,
          required: false,
        },
      },

      data() {
        return {
          data: this.datatable
        }
      },

      watch: {},

      computed: {},

      methods: {
        splitBySeparator(item, sep) {
          return item.split(sep)
        }
      },

    }
</script>

<style scoped>
  #table-cell {
    font-size: 0.75rem;
  }
</style>
